<template>
  <div>
    <basic-container id="printBox">
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange" @row-save="handleSave" @row-update="handleUpdate"
        @selection-change="handleSelectionChange" @size-change="pageSizeChange" @current-change="pageChange">
        <template slot-scope="scope" slot="menuLeft">
          <!-- <el-button type="primary" icon="el-icon-plus" size="small" plain @click.stop="handleAdd()">新增商品入库</el-button> -->
          <el-button type="primary" icon="el-icon-plus" size="small" plain @click.stop="addProd()">新增商品</el-button>
          <el-button type="danger" icon="el-icon-sort-down" size="small" plain @click.stop="productDown">下架</el-button>
          <el-button type="danger" icon="el-icon-sort-up" size="small" plain @click.stop="productPutAway">上架</el-button>
          <el-button type="success" icon="el-icon-download" size="small" plain
            @click.stop="downloadExcelWarehousing">导出Excel</el-button>
          <el-button type="warning" icon="el-icon-printer" size="small" plain @click.stop="printJson()">打印</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="success" icon="el-icon-view" size="small" plain @click.stop="toLog(scope)">查看</el-button>
          <!-- <el-button type="info" size="small" icon="el-icon-edit" plain
            @click.stop="handleEdit(scope.row, scope.index, isEdits)">编辑0</el-button> -->
            <el-button type="info" size="small" icon="el-icon-edit" plain
            @click.stop="addOrEditProd(scope.row, scope.index, isEdits)">编辑</el-button>
          <el-button type="primary" icon="el-icon-upload2" size="small" plain
            @click.stop="handleCell(scope.row)">入库</el-button>
        </template>
        <template slot-scope="scope" slot="brandNameForm">
          <el-select v-model="brand" placeholder="请选择品牌" required value-key="id">
            <el-option v-for="brand in brands" :key="brand.id" :label="brand.name" :value="brand"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="firstClassifyNameForm">
          <el-select v-model="classify" placeholder="一级分类" required :disabled="isEdit" @change="chooseSecondClassify"
            clearable value-key="id">
            <el-option v-for="classify in classifies" :key="classify.id" :label="classify.name"
              :value="classify"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="secondClassifyNameForm">
          <el-select v-model="secondClassify" placeholder="二级分类" required :disabled="isEdit" clearable
            @change="findProductSkuClassify" value-key="id">
            <el-option v-for="secondClassify in secondClassifies" :key="secondClassify.id" :label="secondClassify.name"
              :value="secondClassify"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="skuForm">
          <el-select v-model="sku" placeholder="请选择SKU组合" required @change="findConstituteBySkuId" value-key="id"
            clearable :disabled="isEdit">
            <el-option v-for="sku in skuList" :key="sku.id" :label="sku.skuName" :value="sku"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="joinsWorkServiceCategoryForm">
          <el-select v-model="joinsWorkServiceCategory" placeholder="请选择服务类目" required @change="choseWorkServiceItem"
            value-key="id">
            <el-option v-for="joinsWorkServiceCategory in joinsWorkServiceCategorys" :key="joinsWorkServiceCategory.id"
              :label="joinsWorkServiceCategory.name" :value="joinsWorkServiceCategory"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="joinsWorkServiceItemForm">
          <el-select v-model="joinsWorkServiceItem" placeholder="请选择服务项目" required @change="findCoupon" value-key="id">
            <el-option v-for="joinsWorkServiceItem in joinsWorkServiceItems" :key="joinsWorkServiceItem.id"
              :label="joinsWorkServiceItem.name" :value="joinsWorkServiceItem"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="statusForm">
          <el-radio v-model="productStatus" label="SOLD_IN">上架</el-radio>
          <el-radio v-model="productStatus" label="SOLD_OUT">下架</el-radio>
        </template>
        <template slot-scope="scope" slot="describes">
          <div v-viewer="{ movable: false }" :images="describes">
            <img v-for="(src, index) in scope.row.describeUrl" :src="src" :key="index" style="width:10px;height:auto" />
          </div>
        </template>
        <template slot-scope="scope" slot="wheels">
          <div v-viewer="{ movable: false }" :images="describes">
            <img v-for="(src, index) in scope.row.wheelUrl" :src="src" :key="index" style="width:10px;height:auto" />
          </div>
        </template>
        <template slot-scope="scope" slot="mainImageForm">
          <el-upload :multiple="true" action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList0" :http-request="fnUploadMainImage" :show-file-list="false">
            <div v-if="mainImage != '' && mainImage != null" class="el-upload el-upload--picture-img">
              <img :src="mainImage" style="width: 200px;" />
              <a style="margin-left: 20px" @click.stop="deleteMain(mainImage)">删除</a>
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传一张jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
        <template slot-scope="scope" slot="describesForm">
          <el-upload :multiple="true" action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList" :http-request="fnUploadDescribeImgs" :show-file-list="false">
            <div v-if="'' != describes" class="el-upload el-upload--picture-img">
              <div :key="describeImg.id" v-for="describeImg of describes">
                <img :src="describeImg" style="width: 200px;" />
                <a style="margin-left: 20px" @click.stop="deleteDes(describeImg)">删除</a>
              </div>
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
        <template slot-scope="scope" slot="wheelsForm">
          <el-upload :multiple="true" action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList1" :http-request="fnUploadWheelsImgs" :show-file-list="false">
            <div v-if="'' != wheels" class="el-upload el-upload--picture-img">
              <div :key="wheelsImg.id" v-for="wheelsImg of wheels">
                <img :src="wheelsImg" style="width: 200px;" />
                <a style="margin-left: 20px" @click.stop="deletePic(wheelsImg)">删除</a>
              </div>
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
        <template slot-scope="scope" slot="productStatus">
          <el-tag v-for="obj of productStatuses" :key="obj.value" v-if="obj.value == scope.row.productStatus">{{
        obj.label
      }}</el-tag>
        </template>
        <template slot-scope="scope" slot="constituteForm">
          <div>
            <el-table :data="constitutes" border>
              <template v-for="(col, index) in tableData1">
                <el-table-column sortable :show-overflow-tooltip="true" :prop="col.dataItem" :label="col.dataName"
                  :key="col.dataItem" width="124px">
                  <template slot-scope="scope">
                    <!-- 如果是img，那么需要上传sku图片（单张），每一个循环出来的都需要上传sku图片 -->
                    <div v-if="col.isImage && col.dataName == 'SKU图片'">
                      <el-upload :file-list="scope.row[col.flag] ? [{ url: scope.row[col.flag] }] : []" action="#"
                        accept="image/jpeg, image/gif, image/png, image/bmp"
                        :http-request="(option) => fnUploadSkuImage(option, scope.$index, col.flag)"
                        :show-file-list="false">
                        <el-button type="sucess" icon="el-icon-upload" size="mini"
                          v-if="!scope.row[col.flag]">点击上传</el-button>
                      </el-upload>
                      <div v-if="scope.row[col.flag]">
                        <img :src="scope.row[col.flag]" style="width: 50px; height: 50px;">
                        <el-button type="text" size="small"
                          @click="deleteSkuImage(scope.$index, col.flag)">删除</el-button>
                      </div>
                    </div>
                    <!-- <el-input type="input" v-if="col.dataName == '入库量'" :disabled="col.disabled" :name="col.dataName"
                      v-model="scope.row[index]" :placeholder="col.placeholder"
                      onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"></el-input>
                    <el-input type="input" v-else :disabled="col.disabled" :name="col.dataName"
                      v-model="scope.row[index]" :placeholder="col.placeholder"></el-input> -->
                      <el-input v-if="col.dataName == '入库量'" type="input" :name="col.dataName" v-model="scope.row[index]"
                      :placeholder="col.placeholder"
                      onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"></el-input>
                    <el-input v-else-if="col.dataName !=='SKU图片'" type="input" :name="col.dataName" v-model="scope.row[index]"
                      :placeholder="col.placeholder"></el-input>
                  </template>
                </el-table-column>
              </template>

              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button plain type="danger" icon="el-icon-delete" size="small"
                    @click="handleSteppingDelete(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 20px">
              <el-button @click="handleAddRows()">增加一行</el-button>
            </div>
          </div>
        </template>
        <template slot-scope="scope" slot="status">
          <el-tag v-if="scope.row.status == 'SOLD_IN'" type="success">上架</el-tag>
          <el-tag v-else type="danger">下架</el-tag>
        </template>
      </avue-crud>
      <el-dialog :visible.sync="dialogTableVisible">
        <div>
          <template>
            <el-select v-model="sku" placeholder="请选择SKU组合" required disabled @change="findConstituteBySkuId"
              value-key="id">
              <el-option v-for="sku in skuList" :key="sku.id" :label="sku.skuName" :value="sku"></el-option>
            </el-select>
          </template>
          <div>
            <el-table :data="constitutes" border>
              <template v-for="(col, index) in tableData1">
                <el-table-column sortable :show-overflow-tooltip="true" :prop="col.dataItem" :label="col.dataName"
                  :key="col.dataItem" width="124px">
                  <template slot-scope="scope">
                    <!-- 如果是img，那么需要上传sku图片（单张），每一个循环出来的都需要上传sku图片 -->
                    <div v-if="col.isImage && col.dataName == 'SKU图片'">
                      <div v-if="scope.row[col.flag]">
                        <img :src="scope.row[col.flag]" style="width: 50px; height: 50px;">
                      </div>
                    </div>
                    <!-- <el-input type="input" :name="col.dataName" v-model="scope.row[index]" :placeholder="col.placeholder" @change="checkTheAmountOfStorage(col.dataName,scope.row[index],index,scope.$index)"></el-input> -->
                    <el-input v-if="col.dataName == '入库量'" type="input" :name="col.dataName" v-model="scope.row[index]"
                      :placeholder="col.placeholder"
                      onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"></el-input>
                    <el-input v-else-if="col.dataName !=='SKU图片'" type="input" :name="col.dataName" v-model="scope.row[index]"
                      :placeholder="col.placeholder"></el-input>
                  </template>
                </el-table-column>
              </template>

              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button type="warning" icon="el-icon-delete" size="small"
                    @click="handleSteppingDelete(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 20px">
              <el-button @click="handleAddRows()">增加一行</el-button>
            </div>
          </div>
          <div style="margin-top:15px;">
            <el-button type="success" size="medium" @click="numeStock">确定入库</el-button>
            <el-button type="warning" size="medium" @click="dialogTableVisible = false">取消</el-button>
          </div>
        </div>
      </el-dialog>
      <template slot-scope="scope" slot="describes">
        <template v-if="scope.row.dataType != 'img'">{{
        scope.row.value
      }}</template>
        <template v-if="scope.row.dataType == 'img'">
          <viewer :images="formmaterImage(scope.row.value)">
            <img v-for="src in formmaterImage(scope.row.value)" :src="src" :key="src" width="20" />
          </viewer>
        </template>
      </template>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { warehousingOption } from "@/const/salesCloud/warehousingOption";
import {
  findClassify,
  chooseSecondClassify,
  chooseFirstSku,
  findConstituteBySkuId,
  findProductSkuClassify,
  findBrand,
  goodsDown,
  goodsPutAway,
  invoiceSystemV2Put,
  invoiceSystemV2PutPut,
  invoiceSystemV2PutAdd,
  invoiceSystemV2PutEdit,
  invoiceSystemV2PutDownload,
} from "@/api/salesCloud/stockGoods";
import { formatterDateToUTC, resolveUrlPath } from "@/util/util";
import { getCompany } from "@/util/auth";
import { findCoupon } from "@/api/salesCloud/serviceCoupon";
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";
// import { exportExcel } from "xlsx-oc";

export default {
  name: "warehousing",
  data() {
    return {
      tableOption: warehousingOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      downloadData: {},
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      isEdit: false,
      dialogTableVisible: false,
      grade: {
        box: false,
        check: [],
      },
      isEdits: true,
      productStatuses: DIC.PRODUCT_STATUS,
      brands: [],
      brand: {},
      classifies: [],
      classify: {},
      secondClassifies: [],
      secondClassify: {},
      departments: [],
      department: {},
      productStatus: "SOLD_IN",
      describes: [],
      wheels: [],
      fileList0: [],
      mainImage: "",
      fileList: [],
      fileList1: [],
      prices: [],
      clientTypes: DIC.CLIENT_TYPE,
      sku: {},
      skuList: [],
      tableData1: [],
      constitutes: [],
      dataSku1: [],
      joinsWorkServiceCategorys: [],
      joinsWorkServiceCategory: {},
      joinsWorkServiceItems: [],
      joinsWorkServiceItem: {},
      coupon: {},
      coupons: [],
      rowData: {},
    };
  },
  created() {
    findBrand().then((res) => {
      let data = JSON.parse(res.data);
      // console.log("findBrand", res);
      this.brands = data.rows;
    });
    findClassify().then((res) => {
      let data = JSON.parse(res.data);
      // console.log("findClassify", res);
      this.classifies = data;
    });
    this.handleList();
    // console.log(this);
  },
  watch: {},
  mounted() { },
  computed: {
    ...mapGetters(["permission"]), //获取权限
  },
  props: [],
  methods: {
    addProd() {
      let obj = {
        label: "新增入库",
        value: "warehousing/add",
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
      });
    },
    addOrEditProd(row, index, isEdits) {
      let obj = {
        label: "修改入库信息",
        value: "warehousing/Edit",
        query: {
          row: row,
          index: index,
          isEdits: isEdits,
        },
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query,
      });
    },
    deleteMain() {
      this.mainImage = "";
    },
    // 主图只能上传一张
    async fnUploadMainImage(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList0 = files;
            let array = results.res.requestUrls[0].split("?");
            this.mainImage = array[0];
            this.tableLoading = false;
          })
          .catch(err => {
            this.tableLoading = false;
            this.$message({
              showClose: true,
              message: err,
              type: "error"
            });
          });
      });
    },
    /**
         * @description 上传sku图片
         */
    async fnUploadSkuImage(option, rowIndex, colIndex) {
      this.tableLoading = true;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client.multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let array = res[0].split("?");
            let url = array[0];
            this.$set(this.constitutes[rowIndex], colIndex, url); // 更新对应SKU项的图片字段
            this.tableLoading = false;
          })
          .catch(err => {
            this.tableLoading = false;
            this.$message({
              showClose: true,
              message: err,
              type: "error"
            });
          });
      });
    },
    /**
         * @description 删除sku图片
         */
    deleteSkuImage(rowIndex, colIndex) {
      this.$set(this.constitutes[rowIndex], colIndex, '');
    },
    deleteDes(describeImg) {
      // console.log(describeImg);
      let index = this.describes.indexOf(describeImg);
      if (index > -1) {
        this.describes.splice(index, 1);
      }
    },
    deletePic(wheelsImg) {
      // console.log(wheelsImg);
      let index = this.wheels.indexOf(wheelsImg);
      if (index > -1) {
        this.wheels.splice(index, 1);
      }
    },

    handleCell(row) {
      this.clean();
      this.rowData = row;
      this.dialogTableVisible = true; // 显示入库对话框
      this.brand.id = row.brandId; //品牌名称回显
      //sku组合回显
      let obj = {};
      obj.firstClassifyId = row.firstClassifyId;
      obj.secondClassifyId = row.secondClassifyId;
      findProductSkuClassify(obj).then((res) => {
        let data = JSON.parse(res.data);
        this.skuList = data;
        this.sku.id = row.skuId;
        findConstituteBySkuId(row.skuId).then((res) => {
          let adata = JSON.parse(res.data);
          this.formatConstitute(adata);
          for (let item of row.obj) {
            let skuLenght = item.skuValue.split(":");
            skuLenght.push(item.stockPrice + "");
            skuLenght.push(item.purchasePrice + "");
            skuLenght.push(item.salePrice + "");
            skuLenght.push(item.amount*0);
            // 图片回显
            skuLenght.push(item.img);
            let obj = Object.assign({}, skuLenght);
            //将obj数组内的倒数第二个制空
            // obj[obj.length - 2] = '';
            this.constitutes.push(obj);
            // console.log(this.constitutes);
          }
        });
      });
      //图片回显
      this.wheels = row.wheels;
      this.describes = row.describes;
    },
    /**
     * 校验入库数量
     */
    checkTheAmountOfStorage(name, value, index, rowIndex) {
      if (name == "入库量") {
        if (value < 0) {
          this.$message({
            showClose: true,
            message: "入库数量不能小于0",
            type: "error",
          });
        }
        // 入库量只能是整数、空、undefined
        if (value != "" && value != undefined && !/^[0-9]*$/.test(value)) {
          this.$message({
            showClose: true,
            message: "入库数量只能是正整数",
            type: "error",
          });
          // 如果value为空或者undefined，就删掉这个属性
          if (value == "" || value == undefined) {
            delete this.constitutes[rowIndex][index];
          }
          // console.log(this.constitutes, '1');
          // nextTick 保证了在数据更新后再执行
          this.$nextTick(() => {
            // this.constitutes[rowIndex][index]四舍五入为正整数
            this.constitutes[rowIndex][index] = Math.round(value) + "";
          });
          // console.log(this.constitutes,'2');
        }
      }
    },
    //格式化sku组合
    numeStock() {
      let params = {};
      let dataSku = [];
      for (let i = 0; i < this.constitutes.length; i++) {
        let obj = this.constitutes[i];
        let strMap = new Map();
        for (let k of Object.keys(obj)) {
          strMap.set(k, obj[k]);
        }
        // console.log(strMap)
        let ids = "";
        let val = "";
        let skuMap = new Map();
        for (let j = 0; j < this.tableData1.length; j++) {
          let obj1 = this.tableData1[j];
          // console.log(obj1)
          if (typeof obj1.id != "undefined") {
            ids += obj1.id + ":";
            val += strMap.get(j + "") + ":";
          } else {
            skuMap.set(obj1.dataItem, strMap.get(obj1.flag + ""));
          }
        }
        let sku = Object.create(null);
        for (let [k, v] of skuMap) {
          sku[k] = v;
        }
        ids = ids.substring(0, ids.length - 1);
        val = val.substring(0, val.length - 1);
        sku.skuKey = ids;
        sku.skuValue = val;
        sku.skuId = this.sku.id;
        // console.log(sku)
        dataSku.push(sku);
      }

      let row = this.rowData;
      // 将 row 中每个 obj 的 id 添加到 skus 数组对应对象的属性中
      for (let i = 0; i < dataSku.length; i++) {
        // 如果没有 id，就不需要这一步，否则需要将 id 放入 skus 数组对应对象的属性中
        if (row.obj[i] != undefined) {
          dataSku[i].id = row.obj[i].id;
        }

      }

      // console.log(this.constitutes);
      params.skus = dataSku;
      params.name = row.name;
      params.id = row.id;
      params.status = row.status;
      params.unit = row.unit;

      params.brandId = row.brandId ? row.brandId : "";
      params.firstClassifyId = row.firstClassifyId ? row.firstClassifyId : "";
      params.secondClassifyId = row.secondClassifyId
        ? row.secondClassifyId
        : "";
      if (dataSku[0] != undefined) {
        params.skuId = dataSku[0].skuId ? dataSku[0].skuId : "";
        // console.log("入库params", params);
        invoiceSystemV2PutPut(params).then((res) => {
          // console.log(res);
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
            });
            this.rowData = {};
            this.handleList();
            this.dialogTableVisible = false;
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
          }
        })
          .catch((error) => {
            this.loading = false;
            this.$message({
              showClose: true,
              message: error,
              type: "error",
            });
          });
      } else {
        this.$message({
          showClose: true,
          message: "请填写商品属性",
          type: "error",
        });
      }
      // console.log(dataSku);
      // console.log(row);
      // console.log(params);
    },
    formmaterImage(row) {
      let str = new Array();
      // console.log("row：" + JSON.stringify(row));
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },
    handleEdit(row, index, isEdits) {
      console.log(row);
      this.clean();
      this.isEdit = true;
      this.brand.id = row.brandId; //品牌名称回显
      this.classify.id = row.firstClassifyId; //一级分类回显
      //二级分类回显
      chooseSecondClassify(this.classify.id).then((res) => {
        let data = JSON.parse(res.data);
        this.secondClassifies = data;
        this.secondClassify.id = row.secondClassifyId;
      });
      //sku组合回显
      let obj = {};
      obj.firstClassifyId = row.firstClassifyId;
      obj.secondClassifyId = row.secondClassifyId;
      findProductSkuClassify(obj).then((res) => {
        let data = JSON.parse(res.data);
        this.skuList = data;
        this.sku.id = row.skuId;
        findConstituteBySkuId(row.skuId).then((res) => {
          let adata = JSON.parse(res.data);
          this.formatConstitute(adata, isEdits);
          console.log(row.obj);
          for (let item of row.obj) {
            let skuLenght = item.skuValue.split(":");
            skuLenght.push(item.stockPrice + "");
            skuLenght.push(item.purchasePrice + "");
            skuLenght.push(item.salePrice + "");
            skuLenght.push(item.amount + "");
            // 图片回显
            skuLenght.push(item.img);
            let obj = Object.assign({}, skuLenght);
            this.constitutes.push(obj);
            // console.log(this.constitutes);
          }
        });
      });
      this.mainImage = row.mainImage;
      //图片回显
      this.wheels = row.wheels;
      this.describes = row.describes;
      this.$refs.crud.rowEdit(row, index);
    },
    toLog(scope) {
      // console.log(scope.row);
      this.$router.push({
        name: "商品入库记录",
        params: { id: scope.row.id },
      });
    },
    handleAddRows() {
      // console.log(this.constitutes)
      let obj = "{";
      for (let i = 0; i < this.tableData1.length; i++) {
        if (i != this.tableData1.length - 1) {
          obj += "" + i + ":'',";
        } else {
          obj += "" + i + ":''";
        }
      }
      obj += "}";
      let dataObj = eval("(" + obj + ")");
      this.constitutes.push(dataObj);
      // console.log(this);
      // console.log(this.constitutes)
    },
    handleSteppingDelete(index) {
      // console.log(this.constitutes, 1111)
      this.constitutes.splice(index, 1);
      this.dataSku1.splice(index, 1);
      // console.log(this.dataSku1, 2222)
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      invoiceSystemV2Put(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      invoiceSystemV2Put(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      this.downloadData = params;
      // console.log("searchChange", params);
      this.findShopGoodList(params);
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.page.currentPage;
      params.size = page.page.pageSize;
      this.downloadData = params;
      // console.log(page);
      this.findShopGoodList(params);
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // console.log(this.describes)
      this.prices = [];
      this.clean();
      this.isEdit = false;
      this.$refs.crud.rowAdd();
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      this.downloadData = params;
      this.findShopGoodList(params);
    },
    findShopGoodList(params) {
      invoiceSystemV2Put(params).then((res) => {
        let data = JSON.parse(res.data);
        // console.log(data);
        // console.log(res);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done, loading) {
      let params = {};
      let dataSku = [];
      for (let i = 0; i < this.constitutes.length; i++) {
        let obj = this.constitutes[i];
        let strMap = new Map();
        for (let k of Object.keys(obj)) {
          strMap.set(k, obj[k]);
        }
        // console.log(strMap)
        let ids = "";
        let val = "";
        let skuMap = new Map();
        for (let j = 0; j < this.tableData1.length; j++) {
          let obj1 = this.tableData1[j];
          // console.log(obj1)
          if (typeof obj1.id != "undefined") {
            ids += obj1.id + ":";
            val += strMap.get(j + "") + ":";
          } else {
            skuMap.set(obj1.dataItem, strMap.get(obj1.flag + ""));
          }
        }
        let sku = Object.create(null);
        for (let [k, v] of skuMap) {
          sku[k] = v;
        }
        ids = ids.substring(0, ids.length - 1);
        val = val.substring(0, val.length - 1);
        sku.skuKey = ids;
        sku.skuValue = val;
        sku.skuId = this.sku.id;
        dataSku.push(sku);
      }
      params.name = row.name;
      params.status = row.status;
      params.unit = row.unit;
      params.skuId = this.sku.id ? this.sku.id : "";
      params.skus = dataSku;
      params.brandId = this.brand.id ? this.brand.id : "";
      params.firstClassifyId = this.classify.id ? this.classify.id : "";
      params.secondClassifyId = this.secondClassify.id
        ? this.secondClassify.id
        : "";
      params.describes = this.describes;
      params.wheels = this.wheels;
      params.mainImage = this.mainImage;
      // console.log(params);
      invoiceSystemV2PutAdd(params)
        .then((res) => {
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
            });
            this.handleList();
            done();
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
            loading();
          }
        })
    },
    handleUpdate(row, index, done) {
      let params = {};
      let dataSku = [];
      // console.log(this.constitutes);
      // console.log(this.tableData1.length);
      for (let i = 0; i < this.constitutes.length; i++) {
        let obj = this.constitutes[i];
        let strMap = new Map();
        for (let k of Object.keys(obj)) {
          strMap.set(k, obj[k]);
        }
        // console.log(strMap)
        let ids = "";
        let val = "";
        let skuMap = new Map();
        for (let j = 0; j < this.tableData1.length; j++) {
          let obj1 = this.tableData1[j];
          // console.log(obj1)
          if (typeof obj1.id != "undefined") {
            ids += obj1.id + ":";
            val += strMap.get(j + "") + ":";
          } else {
            skuMap.set(obj1.dataItem, strMap.get(obj1.flag + ""));
          }
        }
        let sku = Object.create(null);
        for (let [k, v] of skuMap) {
          sku[k] = v;
        }
        ids = ids.substring(0, ids.length - 1);
        val = val.substring(0, val.length - 1);
        sku.skuKey = ids;
        sku.skuValue = val;
        sku.skuId = this.sku.id;
        sku.id = row.obj[i].id;
        sku.amount = "0";
        // console.log(sku);
        dataSku.push(sku);
      }
      params.id = row.id;
      params.name = row.name;
      params.status = row.status;
      params.unit = row.unit;
      params.mainImage = this.mainImage;
      params.skuId = this.sku.id ? this.sku.id : "";
      params.skus = dataSku;
      params.brandId = this.brand.id ? this.brand.id : "";
      params.firstClassifyId = this.classify.id ? this.classify.id : "";
      params.secondClassifyId = this.secondClassify.id
        ? this.secondClassify.id
        : "";
      params.describes = this.describes;
      params.wheels = this.wheels;
      // console.log(params);
      invoiceSystemV2PutEdit(params)
        .then((res) => {
          // console.log(res);
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel() { },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    chooseSecondClassify() {
      this.secondClassify = {};
      this.sku = {};
      chooseSecondClassify(this.classify.id).then((res) => {
        let data = JSON.parse(res.data);
        this.secondClassifies = data;
      });
      chooseFirstSku(this.classify.id).then((res) => {
        let data = JSON.parse(res.data);
        this.skuList = data;
      });
    },
    async fnUploadWheelsImgs(option) {
      if (this.wheels.length >= 5) {
        this.$message({
          showClose: true,
          message: "轮播图不能超过五张",
          type: "error",
        });
        return;
      }
      this.tableLoading = true;
      getAliyunPublicToken().then((res) => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken,
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        // console.log(storeAs)
        client
          .multipartUpload(storeAs, option.file, {})
          .then((results) => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList1 = files;
            let array = results.res.requestUrls[0].split("?");
            this.wheels.push(array[0]);
            this.tableLoading = false;
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    async fnUploadDescribeImgs(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then((res) => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken,
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        // console.log(storeAs)
        client
          .multipartUpload(storeAs, option.file, {})
          .then((results) => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            this.describes.push(array[0]);
            this.tableLoading = false;
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    productDown() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error",
        });
        return;
      }

      this.$confirm(`是否确认下架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }
          // console.log(ids);
          goodsDown(ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "下架成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => { });
    },
    productPutAway() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error",
        });
        return;
      }

      this.$confirm(`是否确认上架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }
          goodsPutAway(ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "上架成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => { });
    },
    findProductSkuClassify() {
      let obj = {};
      // 清除sku组合框的值
      this.sku = {};
      obj.firstClassifyId = this.classify.id;
      obj.secondClassifyId = this.secondClassify.id;
      if (obj.secondClassifyId == undefined) {
        delete obj.secondClassifyId;
      }
      findProductSkuClassify(obj).then((res) => {
        let data = JSON.parse(res.data);
        this.skuList = data;
        // console.log(data);
      });
    },
    findConstituteBySkuId() {
      findConstituteBySkuId(this.sku.id).then((res) => {
        let data = JSON.parse(res.data);
        this.formatConstitute(data);
      });
    },
    findStockWarehousingSkuId(scope) {
      // console.log(this.scope);
      console.log(scope);
    },
    formatConstitute(data, isEdits) {
      let flag = 0;
      this.tableData1 = new Array(data.length + 4);
      for (let i = 0; i < data.length; i++) {
        let obj = {};
        obj.dataItem = data[i].constituteCode;
        obj.dataName = data[i].constituteName;
        obj.placeholder = data[i].constituteName;
        obj.id = data[i].id;
        obj.flag = flag;
        this.tableData1[flag] = obj;
        flag++;
      }
      this.tableData1[flag] = {
        dataItem: "stockPrice",
        dataName: "进货价",
        placeholder: "进货价",
        flag: flag,
        disabled: false,
      };
      this.tableData1[flag + 1] = {
        dataItem: "purchasePrice",
        dataName: "采购价",
        placeholder: "采购价",
        flag: flag + 1,
        disabled: false,
      };
      this.tableData1[flag + 2] = {
        dataItem: "salePrice",
        dataName: "零售价",
        placeholder: "零售价",
        flag: flag + 2,
        disabled: false,
      };
      this.tableData1[flag + 3] = {
        dataItem: "amount",
        dataName: isEdits ? "库存" : "入库量",
        placeholder: isEdits ? "库存" : "入库量",
        flag: flag + 3,
        disabled: isEdits ? true : false,
      };
      // 为SKU图片上传添加标记
      this.tableData1.push({
        dataItem: "img",
        dataName: "SKU图片",
        flag: this.tableData1.length,
        isImage: true, // 添加标记，用于区分图片上传列
      });
      // 初始化constitutes数据，为每个SKU项添加img字段
      this.constitutes.forEach((sku) => {
        sku.img = '';
      });
    },
    objToStrMap(obj) {
      let strMap = new Map();
      for (let k of Object.keys(obj)) {
        strMap.set(k, obj[k]);
      }
      return strMap;
    },
    strMapToObj(strMap) {
      let obj = Object.create(null);
      for (let [k, v] of strMap) {
        obj[k] = v;
      }
      return obj;
    },
    findCoupon() {
      let obj = {};
      obj.serviceCategoryId = this.joinsWorkServiceCategory.id;
      obj.serviceItemId = this.joinsWorkServiceItem.id;
      findCoupon(obj).then((res) => {
        let data = JSON.parse(res.data);
        this.coupons = data;
      });
    },
    clean() {
      this.brand = {};
      this.classify = {};
      this.secondClassify = {};
      this.sku = {};
      this.constitutes = [];
      this.joinsWorkServiceCategory = {};
      this.joinsWorkServiceItem = {};
      this.coupon = {};
      this.skuList = [];
      this.tableData1 = [];
      this.constitutes = [];
      this.dataSku1 = [];
      this.describes = [];
      this.mainImage = "";
      this.wheels = [];
    },
    downloadExcelWarehousing() {
      let params = this.downloadData;

      invoiceSystemV2PutDownload(params).then((res) => {
        window.open(res);
      });
    },
    printJson() {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      this.downloadData = params;
      invoiceSystemV2Put(params).then((res) => {
        let data = JSON.parse(res.data);
        let someJSONdata = data.rows;
        someJSONdata = someJSONdata.map((item) => {
          item.status == "SOLD_IN"
            ? (item.status = "上架")
            : (item.status = "下架");
          return item;
        });
        this.tableLoading = false;
        let s = formatterDateToUTC(new Date().getTime());
        let c = getCompany();
        // eslint-disable-next-line no-undef
        printJS({
          printable: someJSONdata,
          header: `<div style='position:absolute;bottom:0;display:flex;flex-flow: row nowrap;width:100%; justify-content: space-between;'><div>打印时间：${s}</div><div style="margin-right:15px;">${c}</div></div>`,
          properties: [
            { field: "name", displayName: "商品名称" },
            { field: "brandName", displayName: "品牌名称" },
            { field: "unit", displayName: "商品单位" },
            { field: "firstClassifyName", displayName: "一级分类" },
            { field: "secondClassifyName", displayName: "二级分类" },
            { field: "status", displayName: "商品状态" },
            { field: "allAmount", displayName: "总入库量" },
            { field: "amount", displayName: "现有库存" },
          ],
          targetStyles: "width:200px",
          gridHeaderStyle:
            "border: 1px solid  lightgray;white-space:nowrap;padding:0px 8px;text-align:center ",
          gridStyle:
            "border: 1px solid lightgray;white-space:nowrap;padding:8px 10px ;text-align:center",
          type: "json",
        });
      });
    },
  },
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
